export interface DashboardState {
  selectedCounty: string
  appBarVisible: boolean
  initialSetupCompleted: boolean
}

export const initialDashboardState: DashboardState = {
  selectedCounty: 'all',
  appBarVisible: true,
  initialSetupCompleted: false,
}
